import { render, staticRenderFns } from "./PhotoAttachmentModal.vue?vue&type=template&id=07ffcfd5&scoped=true&"
import script from "./PhotoAttachmentModal.vue?vue&type=script&lang=js&"
export * from "./PhotoAttachmentModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotoAttachmentModal.vue?vue&type=style&index=0&id=07ffcfd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ffcfd5",
  null
  
)

export default component.exports